/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fixed: NonNullable<unknown>, flex: NonNullable<unknown> }} Profile_Days_Fixed_And_FlexInputs */

const en_us2_profile_days_fixed_and_flex = /** @type {(inputs: Profile_Days_Fixed_And_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fixed} + ${i?.flex}`)
};

const pt_br2_profile_days_fixed_and_flex = /** @type {(inputs: Profile_Days_Fixed_And_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fixed} + ${i?.flex}`)
};

const es_419_profile_days_fixed_and_flex = /** @type {(inputs: Profile_Days_Fixed_And_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fixed} + ${i?.flex}`)
};

const pt_pt2_profile_days_fixed_and_flex = /** @type {(inputs: Profile_Days_Fixed_And_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fixed} + ${i?.flex}`)
};

const fr_fr2_profile_days_fixed_and_flex = /** @type {(inputs: Profile_Days_Fixed_And_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fixed} + ${i?.flex}`)
};

const de_de2_profile_days_fixed_and_flex = /** @type {(inputs: Profile_Days_Fixed_And_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fixed} + ${i?.flex}`)
};

const it_it2_profile_days_fixed_and_flex = /** @type {(inputs: Profile_Days_Fixed_And_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fixed} + ${i?.flex}`)
};

/**
* | output |
* | --- |
* | "{fixed} + {flex}" |
*
* @param {Profile_Days_Fixed_And_FlexInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_days_fixed_and_flex = /** @type {((inputs: Profile_Days_Fixed_And_FlexInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Days_Fixed_And_FlexInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_days_fixed_and_flex(inputs)
	if (locale === "es-419") return es_419_profile_days_fixed_and_flex(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_days_fixed_and_flex(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_days_fixed_and_flex(inputs)
	if (locale === "de-DE") return de_de2_profile_days_fixed_and_flex(inputs)
	if (locale === "it-IT") return it_it2_profile_days_fixed_and_flex(inputs)
	return en_us2_profile_days_fixed_and_flex(inputs)
});
export { profile_days_fixed_and_flex as "profile.days_fixed_and_flex" }